import angular from 'angular'

/* @ngInject */
const backButton = ($window) => {
  const $win = angular.element($window)

  return {
    restrict: 'A',

    link: {
      pre: (scope, element, attrs) => {
        element.addClass('back-button')
      },
      post: (scope, element, attrs, ctrl) => {
        $win.on('scroll', (e) => {
          if ($win.scrollTop() >= 62) {
            element.removeClass('back-button')
            element.addClass('back-button-scrolled')
          } else {
            element.addClass('back-button')
            element.removeClass('back-button-scrolled')
          }
        })
      },
    },
  }
}

export default backButton



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/styles/backButton.js